export * from './ort-kategories.query.module';
export * from './service';